var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControllerDevice(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 60,
    viewBox: "0 0 212 60",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.688 3.55762H31.2313C16.8415 3.55762 5.17627 15.2121 5.17627 29.5887C5.17627 43.9653 16.8415 55.6198 31.2313 55.6198H180.688C195.078 55.6198 206.743 43.9653 206.743 29.5887C206.743 15.2121 195.078 3.55762 180.688 3.55762Z",
    stroke: "#231815",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.887 1H30.1126C14.3103 1 1.5 13.8103 1.5 29.6126V29.6526C1.5 45.4549 14.3103 58.2652 30.1126 58.2652H181.887C197.69 58.2652 210.5 45.4549 210.5 29.6526V29.6126C210.5 13.8103 197.69 1 181.887 1Z",
    stroke: "#231815",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4112 11.9497H24.8376C23.6458 11.9497 22.6797 12.9158 22.6797 14.1076V45.2618C22.6797 46.4536 23.6458 47.4198 24.8376 47.4198H52.4112C53.603 47.4198 54.5692 46.4536 54.5692 45.2618V14.1076C54.5692 12.9158 53.603 11.9497 52.4112 11.9497Z",
    stroke: "#231815",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7329 14.5073H26.6759C26.0138 14.5073 25.4771 15.0441 25.4771 15.7062V39.7472C25.4771 40.4093 26.0138 40.946 26.6759 40.946H50.7329C51.395 40.946 51.9317 40.4093 51.9317 39.7472V15.7062C51.9317 15.0441 51.395 14.5073 50.7329 14.5073Z",
    stroke: "#231815",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.807 26.176H76.5483V41.833H140.807V26.176Z",
    stroke: "#231815",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.045 26.176H166.542V41.1057H184.045V26.176Z",
    stroke: "#231815",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9322 28.334H79.1055V37.6051H82.9418V39.2036H83.9009V40.5623H88.1368V39.2036H89.0959V37.6051H92.9322V28.334Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4623 38.0847H79.1055V39.9389H82.4623V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.932 38.0847H89.5752V39.9389H92.932V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.879 28.334H94.1318V37.6051H97.9682V39.2036H98.9272V40.5623H103.163V39.2036H104.122V37.6051H107.879V28.334Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4886 38.0847H94.1318V39.9389H97.4886V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.958 38.0847H104.602V39.9389H107.958V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.984 28.334H109.237V37.6051H113.074V39.2036H114.033V40.5623H118.269V39.2036H119.228V37.6051H122.984V28.334Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.594 38.0847H109.237V39.9389H112.594V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.064 38.0847H119.707V39.9389H123.064V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.089 28.334H124.342V37.6051H128.178V39.2036H129.057V40.5623H133.373V39.2036H134.252V37.6051H138.089V28.334Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.699 38.0847H124.342V39.9389H127.699V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.17 38.0847H134.813V39.9389H138.17V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.738 38.0847H168.381V39.9389H171.738V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M182.207 38.0847H178.851V39.9389H182.207V38.0847Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M182.687 31.6908H181.408V28.334H169.18V31.6908H168.061V35.0476H169.18V37.6051H172.217V39.2036H173.176V40.5623H177.412V39.2036H178.371V37.6051H181.408V35.0476H182.687V31.6908Z",
    stroke: "#231815",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8285 58.2249H28.4346C28.0374 58.2249 27.7153 58.5451 27.7153 58.9402C27.7153 59.3352 28.0374 59.6555 28.4346 59.6555H34.8285C35.2258 59.6555 35.5478 59.3352 35.5478 58.9402C35.5478 58.5451 35.2258 58.2249 34.8285 58.2249Z",
    fill: "#231815"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.326 58.2249H176.932C176.534 58.2249 176.212 58.5451 176.212 58.9402C176.212 59.3352 176.534 59.6555 176.932 59.6555H183.326C183.723 59.6555 184.045 59.3352 184.045 58.9402C184.045 58.5451 183.723 58.2249 183.326 58.2249Z",
    fill: "#231815"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerDevice);
export default __webpack_public_path__ + "static/media/controller-device.c6d623c8f6306e44c4eaa76c785c317c.svg";
export { ForwardRef as ReactComponent };